export class CButton extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    const type = this.getAttribute('type') || 'primary';
    const size = this.getAttribute('size') || 'M';
    const isDisabled = this.hasAttribute('disabled');
    const loading = this.hasAttribute('loading');

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline-block;
        }
        button {
          all: unset;
          cursor: ${isDisabled ? 'not-allowed' : 'pointer'};
          font-family: var(--tempora-font, sans-serif);
          border-radius: 8px;
          font-weight: 500;
          text-align: center;
          transition: all 0.3s ease;
          padding: 0.75rem 1.5rem;
          border: 2px solid transparent;
          opacity: ${isDisabled ? '.3' : '1'};
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          column-gap: 5px;
        }
        .button-text{
          display: ${loading ? 'none' : 'flex'};
          flex-direction: row;
          column-gap: 5px;
          align-items: center
        }

        /* Size variants */
        .size-L {
          font-size: 1.1rem;
          padding: 1rem 2rem;
        }
        .size-M {
          font-size: 1rem;
          padding: 0.75rem 1.5rem;
        }
        .size-S {
          font-size: 0.875rem;
          padding: 0.5rem 1rem;
        }

        /* Type variants */
        .primary {
          background-color: var(--tempora-primary);
          color: white;
          border: none;
        }
        .primary:hover {
          background-color: ${!isDisabled ? 'var(--tempora-primary-hover)' : 'var(--tempora-primary)'};
        }
        .primary:active {
          background-color: ${!isDisabled ? 'var(--tempora-primary-active)' : 'var(--tempora-primary)'};
        }

        .flat {
          background: transparent;
          color: var(--tempora-primary) !important;
        }
        .flat:hover {
          background: ${!isDisabled ? 'var(--tempora-primary-200)' : 'transparent'};
        }
        .flat:active {
          background: ${!isDisabled ? 'var(--tempora-primary-300)' : 'transparent'};
        }

        .outline {
          background: transparent;
          border: 2px solid var(--tempora-primary);
          color: var(--tempora-primary);
        }
        .outline:hover {
          background: ${!isDisabled ? 'var(--tempora-primary-200)' : 'transparent'};
        }
        .outline:active {
          background: ${!isDisabled ? 'var(--tempora-primary-300)' : 'transparent'};
        }
        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid ${type == 'flat' ? 'var(--tempora-primary)' : type == 'outline' ? 'var(--tempora-primary)' : 'white'};
          border-top: 2px solid transparent;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>

      <button class="${type} size-${size}" ${isDisabled ? 'disabled' : ''}>
        <span class="button-text" ${loading ? 'hidden' : ''}>
          <slot></slot>
        </span>
        <span class="spinner" ${loading ? '' : 'hidden'}></span>
      </button>
    `;
  }
  connectedCallback() {
    this.shadowRoot.querySelector("button").addEventListener("click", () => {
      this.dispatchEvent(new Event("click", { bubbles: true, composed: true }));
    });
  }
}

customElements.define('c-button', CButton);